export const SAMPLE_QUERY = {
    dimensions: ['reporting.site_country'],
    measures: ['reporting.participant_count'],
};
export const SAMPLE_REPORTS = [
    {
        title: 'Participants by Country',
        chartType: 'line',
        query: {
            measures: ['reporting.task_response_count', 'reporting.participant_count'],
            dimensions: ['reporting.site_country'],
        },
    },
    {
        title: 'Participant Status Summary',
        chartType: 'table',
        query: {
            dimensions: ['reporting.site_name', 'reporting.site_number', 'reporting.participant_status'],
            measures: ['reporting.participant_count'],
        },
    },
    {
        title: 'Participant Details',
        chartType: 'table',
        query: {
            dimensions: [
                'reporting.site_name',
                'reporting.site_country',
                'reporting.participant_number',
                'reporting.participant_status',
                'reporting.participant_locale',
            ],
            order: {
                'reporting.site_name': 'asc',
                'reporting.participant_number': 'asc',
            },
        },
    },
    {
        title: 'Step Response',
        chartType: 'table',
        query: {
            dimensions: [
                'reporting.site_name',
                'reporting.site_number',
                'reporting.participant_number',
                'reporting.task_name',
                'reporting.step_text',
                'reporting.step_response_skipped',
                'reporting.step_response_value_with_text',
            ],
        },
    },
    {
        title: 'Task Responses by Month',
        chartType: 'bar',
        query: {
            timeDimensions: [
                {
                    dimension: 'reporting.task_response_end',
                    granularity: 'month',
                },
            ],
            measures: ['reporting.task_response_count'],
            order: {
                'reporting.task_response_end': 'asc',
            },
        },
    },
    {
        title: 'Task Response Status',
        chartType: 'table',
        query: {
            dimensions: [
                'reporting.site_name',
                'reporting.site_number',
                'reporting.participant_number',
                'reporting.task_name',
                'reporting.task_response_end',
                'reporting.task_response_completed',
                'reporting.task_response_status',
            ],
        },
    },
];
